export default __webpack_public_path__ + "static/media/AppStoreBadge.8c4986ee.svg";